import React from 'react';

const Loader = (props) => {
  console.log('loader pos:', props.position);
  return (
    <div className="center-loading">
      <div className="loading-spinner" />
    </div>
  );
};

export default Loader;
